import { useState } from "react";
import { timelineData } from "@/mocks/evidence";

const markStyle: Record<string, string> = {
  石锤: "bg-primary-600 text-background-50",
  反转: "bg-accent-500 text-foreground-950",
  录音: "bg-primary-500 text-background-50",
  新流出: "bg-accent-400 text-foreground-950",
  跟进: "bg-secondary-200 text-secondary-900",
  图证: "bg-secondary-300 text-secondary-950",
  辟谣: "bg-foreground-950 text-background-50",
};

const filters = ["全部", "石锤", "录音", "新流出", "反转", "图证"];

export default function EvidenceTimeline() {
  const [active, setActive] = useState("全部");
  const list = active === "全部" ? timelineData : timelineData.filter((t) => t.mark === active);

  return (
    <section id="timeline" className="mx-auto max-w-[1400px] scroll-mt-24 px-4 py-10 md:px-6 md:py-12">
      <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
        <div>
          <h2 className="flex items-center gap-2 font-display text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
            <i className="ri-history-line text-primary-500" />
            实锤时间线
          </h2>
          <p className="mt-1 text-[13px] text-foreground-500">证据按出现时间归档 · 同一事件的后续以时间线方式追更</p>
        </div>

        {/* 分段过滤 */}
        <div className="flex flex-wrap items-center gap-1 rounded-full border border-background-200 bg-background-100 p-1">
          {filters.map((f) => (
            <button
              key={f}
              type="button"
              onClick={() => setActive(f)}
              className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-[13px] font-medium transition-colors ${
                active === f
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:text-primary-600"
              }`}
            >
              {f}
            </button>
          ))}
        </div>
      </div>

      {/* 时间线流 */}
      <div className="relative">
        <span className="absolute bottom-2 left-[86px] top-2 hidden w-px bg-background-200 sm:block" aria-hidden />
        <div className="flex flex-col gap-3">
          {list.map((it) => (
            <a
              key={it.title}
              href="#chat"
              className="group relative flex gap-4 rounded-lg border border-background-200 bg-background-100 p-4 transition-all hover:border-primary-300 hover:bg-background-50 sm:gap-5 md:p-4"
            >
              {/* 时间 */}
              <div className="hidden w-[70px] shrink-0 pt-0.5 sm:block">
                <span className="eyebrow block text-[11px] font-bold text-foreground-500">{it.time.slice(0, 5)}</span>
                <span className="block text-[11px] text-foreground-400">{it.time.slice(6)}</span>
              </div>

              {/* 标记 */}
              <div className="flex w-12 shrink-0 flex-col items-center sm:pt-0">
                <span
                  className={`z-10 flex h-7 w-7 items-center justify-center rounded-full text-[10px] font-bold ${
                    markStyle[it.mark] ?? "bg-secondary-100 text-secondary-900"
                  }`}
                >
                  {it.mark.slice(0, 1)}
                </span>
                <span className="mt-1 hidden text-[10px] font-medium text-foreground-500 sm:block">{it.mark}</span>
              </div>

              {/* 内容 */}
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <h3 className="text-[15px] font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                    {it.title}
                  </h3>
                  <span className="flex items-center gap-1 text-[11px] font-medium text-primary-600">
                    <i className="ri-fire-fill text-accent-500" />
                    {it.heat}
                  </span>
                </div>
                <p className="clamp-2 mt-1 text-[13px] leading-6 text-foreground-600">{it.summary}</p>
                <div className="mt-2 flex flex-wrap items-center gap-2">
                  {it.evidence.map((e) => (
                    <span
                      key={e}
                      className="flex items-center gap-1 rounded-full bg-background-200 px-2.5 py-0.5 text-[11px] text-foreground-700"
                    >
                      <i className="ri-file-list-3-line text-primary-500" />
                      {e}
                    </span>
                  ))}
                  <span className="ml-auto flex items-center gap-1 text-[11px] text-foreground-400">
                    看事件页
                    <i className="ri-arrow-right-s-line transition-transform group-hover:translate-x-0.5" />
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>

      <div className="mt-5 flex justify-center">
        <a
          href="#chat"
          className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-5 py-2 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
        >
          <i className="ri-loader-3-line" />
          加载更多快讯
        </a>
      </div>
    </section>
  );
}